import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import { Paper, Input } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  root: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(1),
    display: 'flex',
    flexBasis: 420
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  input: {
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.05px'
  }
});

class SearchInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      
    }

    this.onChange = this.onChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let value;

    let propsValue   = `${props.value || ""}`;
    let defaultValue = `${state.defaultValue || ""}`;
    let stateValue   = `${state.value || ""}`;
    
    if(defaultValue !== propsValue) {
      defaultValue = propsValue;
      value = propsValue;
    }
    else {
      value = stateValue;
    }

    return {
      value: value,
      defaultValue: defaultValue
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.value !== nextState.value;
  }

  onChange(event) {
    const { withDelay } = this.props;

    let value = event.target.value;
    this.setState({
      value: value
    });

    if(!withDelay) {
      this.props.onChange(value);
      return;
    }
    if(this.timeoutToken) {
      clearTimeout(this.timeoutToken);
    }
    this.timeoutToken = setTimeout(() => {
      clearTimeout(this.timeoutToken);
      this.props.onChange(value);
    }, 500)
  }

  render() {
    const { 
      classes, className,
      placeholder
    } = this.props;

    const { value } = this.state;

    return <Paper className = { clsx(classes.root, className) } >
      <SearchIcon className = { classes.icon } />
      <Input className = { classes.input }
             disableUnderline
             onChange = { this.onChange }
             placeholder = { placeholder }
             value = { value } />
    </Paper>
  }
}

export default withStyles(styles)(SearchInput);
